export const REMOVE_ICON_RADIUS = 24;
export const REMOVE_ICON_OFFSET = 21;
export const FILE_NAME_PADDING = 16;
export const DOCUMENT_CATEGORY_FOOTER_MESSAGE =
  'Categorize this document by searching for the appropriate subtype. Selecting the subtype will automatically set the document type for you.';
export const ORDER_DOCUMENT_EXTENSION_PDF = '.PDF';
export enum IDP {
  DocumentProcessing = 'Document Processing',
  DataExtraction = 'Data Extraction',
  DocumentType = 'Document Type',
  PsaExtraction = 'PSA Extraction',
  PsaExtractionTooltipTxt = 'Automatically extract key terms and other information from PSA documents',
  PsaExtractionDisabledTooltipTxt = 'PSA Extraction cannot be performed on this document or document type',
}
export const optionFooterMessage = (docAssociationCategory) =>
  `This document is associated with a ${docAssociationCategory} and cannot be edited or removed.`;
export const DOCUMENT_TYPE = [
  {
    name: 'Purchase Sales Agreement (PSA)',
    value: 'Purchase Sales Agreement (PSA)',
    id: 'ClarityFirst_PSA',
  },
];
export const SUB_TITLE =
  'Select optional document processes to initiate after upload';
export const VALID_IDP_DOCUMENTS_KEYWORDS = [
  'SEC-Contract',
  'Contract',
  'PSA',
  'Purchase Agreement',
  'P/A',
  'Sales Contract',
  'Buy Sell Agreement',
  'Sales Agreement',
  'Agreement of Sale',
];
export enum DEFAULT_IDP_DOCUMENT_CATEGORY {
  type = 'Escrow: Signed Instructions#SEC-Contract P/A',
  subType = 'SEC-Contract P/A',
}

export enum IDP_DOCUMENT_STATUS {
  Success = 'success',
  InProgress = 'in-progress',
  Failure = 'failure',
  NotFound = 'not-found',
  Initiated = 'initiated',
}

export enum IDP_TOOLTIP_TXT {
  Success = 'Document processes are ready for review',
  InProgress = 'Document processing activity log',
  Failure = 'Process failed, you may retry initiating',
  ExtractionCheckbox = 'Automatically extract data, dates, and other information from PSA documents',
  DocumentProcessing = 'Processing statuses of documents',
  TooltipId = 'documentProcessing',
}
